import React from "react";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contacts from "./components/Contacts";

export default function App() {
  return (
    <main className="text-gray-400 body-font">
      <Navbar />
      <About />
      <Projects />
      <Skills />
      <Contacts />
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js